module.exports = __webpack_public_path__ + "img/location_filter.4f72ccfa.svg";